import React from 'react';
import { NavLink } from 'react-router-dom';

import GetInTouchButton from '@app/components/Forms/GetInTouch/GetInTouchButton';
import CustomMenu from '@app/components/UI/Header/CustomMenu';
import { menu } from '@app/components/UI/Header/Menu';
import MobileMenu from '@app/components/UI/Header/MobileMenu';
import { PhoneProviderContext } from '@app/components/UI/PhoneProvider/PhoneProvider';
import { useMediaQuery } from '@app/hooks/useMediaQuery';
import PhoneSVG from '@app/images/PhoneSVG';

const logoPng = require('@app/images/extended-logo.svg');

const Header: React.FC = () => {
	const isLargeScreen = useMediaQuery(1400);
	const contextPhone = React.useContext(PhoneProviderContext);

	if (!contextPhone?.state) throw new Error('Error PhoneProvider context');

	return (
		<header className="site-header">
			<div className="site-header__contact-bar">
				<a href={contextPhone.state.phoneNumberHref} className="phone-link">
					<PhoneSVG />
					{contextPhone.state.phoneNumberDisplay}
				</a>
			</div>
			<nav className="navbar navbar-fixed-top">
				<div className="navbar-wrapper">
					<NavLink to="/">
						<img className="site-header-logo" src={logoPng} alt="Logo" />
					</NavLink>
					{!isLargeScreen && <CustomMenu items={menu} isMobile={isLargeScreen} />}
					<div className="site-header-buttons">
						<GetInTouchButton btnText="Schedule" btnClassName="capture-bold btn btn-sm btn-secondary find-a-vet" />
						<a
							href="https://lapoflovejobs.workable.com/"
							target="_blank"
							rel="noopener noreferrer"
							className="btn btn-sm btn-primary"
						>
							Join Our Team
						</a>
						<NavLink to="/find-a-vet" className="btn btn-sm btn-primary">
							Find a Vet
						</NavLink>
						{isLargeScreen && <MobileMenu isMobile={isLargeScreen} />}
					</div>
				</div>
			</nav>
		</header>
	);
};

export default Header;
